import React from "react";
import { NumericFormat } from "react-number-format";

import MpTextField from "../../../../../components/MpTextField";
import { InputAdornment } from "../../../../../components/MuiGenerals";
import { useTranslation } from "../../../../../hooks";
import { getCommonDisplayDecimals } from "../../helpers/getCommonDisplayDecimals";

interface AmountTextFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  component?: React.ComponentType<any>;
  currency?: string;
  decimalLimit: number;
}

const AmountTextField = ({
  label,
  value,
  onChange,
  currency,
  decimalLimit,
}: AmountTextFieldProps) => {
  const { t } = useTranslation("createSwapRequest");

  const decimalScale = getCommonDisplayDecimals(decimalLimit) || 18;

  return (
    <NumericFormat
      label={label || t("peExactPayAmount")}
      value={value}
      onValueChange={(values) => onChange(values.value)}
      customInput={MpTextField}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">{currency}</InputAdornment>
        ),
      }}
      thousandSeparator
      decimalScale={decimalScale}
    ></NumericFormat>
  );
};

export default AmountTextField;
